import React, {
  useState,
  useRef,
  ChangeEvent,
  KeyboardEvent,
  useEffect,
} from "react";
import { Card } from "react-bootstrap";
import LOGO_PNG from "../assets/images/vyapar_live_main_logo.png";
import { UserDataSlice } from "../app/store/userdata.slice";
import { useDispatch } from "react-redux";
import { ApisService } from "../app/core/apis.service";
import { dataDecrypt, dataEncrypt } from "../app/utils/encryption-helper";
import { useLocation, useParams } from "react-router-dom";
interface Props {
  reference: string;
  transactionId?: string;
  type?: string;
}

const LoginOtp = (props: Props) => {
  let isOTPRequested = false;
  const location = useLocation();
  const routerParams = useParams();
  const [otpInput, setOtpInput] = useState("");
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [otp, setOtp] = useState();
  const [routeType, setRouteType] = useState<string>('');
  const [transactionData, setTransactionData] = useState<any>(null);
  const [orderMessage, setOrderMessage] = useState<any>(null);
  const [userName, setUserName] = useState<string>();
  const [isLoading, setIsLoading] = useState<boolean>();

  useEffect(() => {
    if (!isOTPRequested && props.reference) {
      requestOTP();
    }
  }, [props.reference]);

  const handleInputChange = (value: string) => {
    if (isNaN(Number(value))) {
      return;
    }
    if (/^\d{0,4}$/.test(value)) {
      setOtpInput(value);
      setError(false);
    }
    if (value.length === 4) {
      onVerifyOTP(value);
    }
  };

  const onVerifyOTP = async (value: any) => {
    setLoading(true);
    try {
      const verifyRes = await ApisService.verifyOTP(
        Number(value),
        props?.reference as string
      );
      setLoading(false);
      if (!verifyRes.data) {
        setError(true);
      }
      if (verifyRes.data) {
        dispatch(UserDataSlice.actions.otp(otpInput));
      }
    } catch (error) {
      setLoading(false);
    }
  };

  // const skipOTPVerification = async () => {
  //   dispatch(UserDataSlice.actions.otp(11));
  // };

  const requestOTP = async () => {
    setOtpInput('');
    setError(false);
    setLoading(true);
    try {
      switch (props.type) {
        case 'retail':
          const retail_data = await ApisService.getRetailInvoice(
            "sendRetailOTP",
            props.reference
          );
          const retaildecryptData = JSON.parse(dataDecrypt(retail_data?.data?.data));
          if (retaildecryptData) {
            setOtp(retaildecryptData.contact);
          }
          break;

        default:
          const transaction_data = await ApisService.getTransactionData(
            "sendOfflineCustomerOTP",
            props.reference
          );
          const transactionData = JSON.parse(dataDecrypt(transaction_data?.data?.data));
          if (transactionData) {
            setOtp(transactionData.contact);
          }
          break;
      }
      setLoading(false);
      isOTPRequested = true;
    } catch (error) {
      setLoading(false);
    }
  };
  useEffect(() => {
    (async () => {
      try {
        const safeJSONParse = (data: any) => {
          try {
            if (!data) return null;
            return JSON.parse(data);
          } catch (err) {
            return null;
          }
        };

        const decryptedReference = dataDecrypt(props?.reference);
        const decryptedRef = safeJSONParse(decryptedReference);
        if (!decryptedRef) {
          setOrderMessage("");
          return;
        }
        let payload = null;
        if (decryptedRef?.type === "offline_transaction") {
          payload = dataEncrypt(JSON.stringify({ id: routerParams.id }));
        }
        else {
          payload = routerParams.id;
        }
        let res = [];
        setIsLoading(true);
        if (location.pathname.includes('packing') || location.pathname.includes('delivery') || location.pathname.includes('stock')) {
          res = await ApisService.getTransactionData('finInvoiceById', routerParams.id || '');
          setIsLoading(false);
        }
        else {
          res = await ApisService.getTransactionData("getById_v2", payload || '');
          setIsLoading(false);
        }
        const decryptedData = dataDecrypt(res?.data?.data);
        const decryptedTransaction = safeJSONParse(decryptedData);
        setTransactionData(decryptedTransaction[0]);
        if (!decryptedTransaction || decryptedTransaction?.length === 0) {
          setOrderMessage("No transaction details found.");
          return;
        }
        const tx = decryptedTransaction[0];
        if (tx?.sender?.id === tx?.seller?.id) {
          setUserName(tx?.buyer?.name);
        }
        else if (tx?.sender?.id === tx?.buyer?.id) {
          setUserName(tx?.seller?.name);
        }
        let buName = '';
        let userName = '';
        let buHeadName = '';
        if (tx?.sender?.id === tx?.buyer?.id) {
          buName = tx.buyer.name;
          userName = tx.seller.name;
          buHeadName = tx.buyer.head_of_business;
        } else if (tx?.sender?.id === tx?.seller?.id) {
          buName = tx.seller.name;
          userName = tx.buyer.name;
          buHeadName = tx.seller.head_of_business;
        }
        setRouteType(decryptedRef?.type || '');
        if (decryptedRef?.type === "offline_transaction") {
          setOrderMessage(`${buHeadName} from ${buName} has sent you message to discuss about new order.`);
        }
        else {
          if (decryptedTransaction?.length > 0) {
            switch (tx?.status || tx?.invoice_details?.status) {
              case "Order Accepted":
                setOrderMessage(`Your order has been accepted by ${buHeadName} from ${buName}.`);
                break;

              case "PO generated":
                setOrderMessage(`${buHeadName} from ${buName} sent a new order.`);
                break;

              case "Discussion accepted":
                if (tx?.show_quotation_acceptance) {
                  setOrderMessage(`${buHeadName} from ${buName} has sent you a Quotation for your order. Please accept to generate purchase order.`);
                }
                else {
                  setOrderMessage(`Your discussion has been accepted by ${buName}`);
                }
                break;

              case "Invoice generated":
                setOrderMessage(`${buHeadName} from ${buName} has generated invoice for your order`);
                break;

              case "packing completed":
                setOrderMessage(`${buHeadName} from ${buName} has updated packing details for your order`);
                break;

              case "Packing completed":
                setOrderMessage(`${buHeadName} from ${buName} has updated packing details for your order`);
                break;

              case "delivery completed":
                setOrderMessage(`${buHeadName} from ${buName} has updated delivery details for your order`);
                break;

              case "Stock resolved":
                setOrderMessage(`${buHeadName} from ${buName} has updated stock reconciliation details for your order`);
                break;

              case "Payment resolved":
                setOrderMessage(`${buHeadName} from ${buName} has updated the payment details for your order.`)
                break;

              default:
                setOrderMessage("");
                break;
            }
          }
        }
      } catch (error) {
        setOrderMessage("");
      }
    })();
  }, [props]);

  const getGreeting = () => {
    const hours = new Date().getHours();
    if (hours < 12) return "Good Morning";
    else if (hours < 17) return "Good Afternoon";
    else return "Good Evening";
  };


  return (
    <div>
      {!isLoading ?
        <div className="row text-center mt-5 mx-2" style={{ overflow: 'hidden' }}>
          <div className="col-md-4"></div>
          <div className="col-md-4">
            <div className="">
              <Card className="p-3 rounded-4 box-shadow mb-3">
                <div className="d-flex justify-content-between align-items">
                  <div className="fs-5 text-start">Hi <b>{userName}</b>
                    <div className="fw-semibold" style={{ color: '#FFA31C' }}>
                      {getGreeting()} 🙏
                    </div>
                  </div>
                  <div >
                    <img
                      src={LOGO_PNG}
                      style={{ maxWidth: "100%", height: 100 }}
                      alt="Logo"
                    />
                  </div>
                </div>
                {orderMessage &&
                  <div className="card rounded-4 mb-3 box-shadow">
                    <div className="card-body text-start fs-15 p-2">
                      <div className="text-center">{orderMessage}</div>
                      {/* {routeType !== 'offline_transaction' && <div className="ps-2">Status : <b className="primary-color">{transactionData?.status?.replace(/\b\w/g, (char: any) => char.toUpperCase()) || transactionData?.invoice_details?.status?.replace(/\b\w/g, (char: any) => char?.toUpperCase())}</b></div>} */}
                    </div>
                  </div>
                }
                {loading ? (
                  <div className="text-center">
                    {Array.from({ length: 3 }).map((_, index) => (
                      <span className="spinner-grow spinner-grow-sm me-1" role="status" aria-hidden="true" key={index} />
                    ))}
                  </div>
                ) : (
                  <div className="text-start">
                    <div className="fs-14">For safe and secure access please login using OTP sent to your mobile number <b>{otp || `xxxxxxxxxx`}</b></div>
                    <div className=" mt-2">
                      <input
                        className="form-control fs-14"
                        type="text"
                        placeholder="please enter 4 digit OTP"
                        value={otpInput}
                        name=""
                        id=""
                        maxLength={4}
                        onChange={(e: ChangeEvent<HTMLInputElement>) =>
                          handleInputChange(e.target.value)
                        }
                      />
                      {error && (
                        <div className="text-danger fs-14">
                          Invalid OTP. Please enter a valid OTP.
                        </div>
                      )}
                      <p className="fs-14 mt-4 text-center">
                        Don't Receive the OTP?{" "}
                        <span
                          className="text-primary cursor-pointer fw-bold"
                          onClick={requestOTP}
                        >
                          RESEND OTP
                        </span>
                      </p>
                      {/* <b>OTP</b> <input type="number" className=""/> */}
                    </div>
                    {/* <div className="text-start">OTP sent to {otp || `xxxxxxxxxx`}</div>
              <div className="otp-input-field mb-3 text-center">
                <input
                  className="form-control fs-14"
                  type="text"
                  placeholder="please enter 4 digit OTP"
                  value={otpInput}
                  name=""
                  id=""
                  maxLength={4}
                  onChange={(e: ChangeEvent<HTMLInputElement>) =>
                    handleInputChange(e.target.value)
                  }
                />
                {error && (
                  <div className="text-danger">
                    Invalid OTP. Please enter a valid OTP.
                  </div>
                )}
              </div>
              <p className="fs-14">
                Don't Receive the OTP?{" "}
                <span
                  className="text-primary cursor-pointer fw-bold"
                  onClick={requestOTP}
                >
                  RESEND OTP
                </span>
              </p> */}

                    {/* <button className="text-center btn btn-primary otp border-0 mb-3" onClick={onVerifyOTP}>Verify OTP </button> */}
                    {/* <p className="text-center text-primary otp border-0 cursor-pointer">
                <span onClick={skipOTPVerification}>Skip OTP for now</span>
              </p> */}
                    <div></div>
                  </div>
                )}
              </Card>
            </div>
          </div>
          <div className="col-md-4"></div>
        </div> : <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
          <div className="spinner-border text-secondary" role="status"></div>
        </div>}
    </div>
  );
};

export default LoginOtp;
